


import { createSlice } from "@reduxjs/toolkit";

const currentPropertyJourneySlice = createSlice({
    name: 'currentPropertyJourney',
    initialState: {},
    reducers: {
        setCurrentPropertyJourney: (state, action): any => {
            return action.payload
        },
        resetCurrentPropertyJourney: (state): any => {
            return {}
        },
        updateCurrentPropertyJourney: (state, action): any => {
            return {
                ...state,
                ...action.payload
            }
        },
    },
});
export const { setCurrentPropertyJourney, updateCurrentPropertyJourney, resetCurrentPropertyJourney } = currentPropertyJourneySlice.actions;
export default currentPropertyJourneySlice.reducer;